export const isSamePage = (pathname: string, oldPathName: string) => {
  return pathname.split("/").length === oldPathName.split("/").length;
};
